import { render, staticRenderFns } from "./CheckoutDone.vue?vue&type=template&id=64d73b70&scoped=true&"
import script from "./CheckoutDone.vue?vue&type=script&lang=js&"
export * from "./CheckoutDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d73b70",
  null
  
)

export default component.exports